import { Link } from "react-router-dom";
import '../assets/styles/CoopReports.scss';
import combinedInsuranceImage from '../assets/images/combinedbluelogo.png';
import toyotaImage from '../assets/images/toyota-coop-report2.png';
import magnetImage from '../assets/images/magnet_forensics_logo.jpeg';

function CoopReports() {
    return(
    <div className="coop-container" id="coop-reports">
        <h1>Co-op Reports</h1>
        <div className="coop-grid">
            <div className="coop-report">
                <Link to="/combinedcoop" className="coop-img-wrapper">
                    <img src={combinedInsuranceImage} className="zoom" alt="Combined Insurance Co-op" />
                </Link>
                <Link to="/combinedcoop">
                    <h2>IT Project Management & Test Automation Engineering</h2>
                </Link>
                <p>Developed test automation solutions using Python, Selenium, and Pandas. Led UAT automation reducing testing time by 83% and managed third-party risk assessments.</p>
            </div>
            <div className="coop-report">
                <Link to="/toyotacoop" className="coop-img-wrapper">
                    <img src={toyotaImage} className="zoom" alt="Toyota Co-op" />
                </Link>
                <Link to="/toyotacoop">
                    <h2> Software Engineering </h2>
                </Link>
                <p>Developed AGV fleet management and traffic control software using C# .NET, Angular, PostgreSQL, Python leading to preventing 14,750 minutes of recovery time from tag-related issues per year. </p>
            </div>
            <div className="coop-report">
                <Link to="/magnetcoop" className="coop-img-wrapper">
                    <img src={magnetImage} className="zoom" alt="Magnet Forensics Co-op" />
                </Link>
                <Link to="/magnetcoop">
                    <h2> Software Engineering </h2>
                </Link>
                <p>Artifacts Engineering for Magnet Forensics' flagship product, AXIOM. Developed and maintained parsers for various digital artifacts using Python, C#, and .NET, contributing to the recovery of critical evidence in digital forensic investigations. </p>
            </div>
        </div>
    </div>
    );
}

export default CoopReports;